import axios from 'axios'
import { Message } from 'element-ui'
import router from '@/router'

// Cloudflare Workers API 地址
const API_BASE = 'https://car-api.zlq1130.workers.dev/api'

const apiClient = axios.create({
  baseURL: API_BASE,
  timeout: 30000
})

// Request interceptor
apiClient.interceptors.request.use(
  config => {
    const token = localStorage.getItem('admin_token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  error => Promise.reject(error)
)

// Response interceptor
apiClient.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401) {
      localStorage.removeItem('admin_token')
      localStorage.removeItem('admin_user')
      if (router.currentRoute.path !== '/login') {
        router.push('/login').catch(err => {
          if (err.name !== 'NavigationDuplicated') {
            console.error(err)
          }
        })
      }
    }
    const message = error.response?.data?.message || 'An error occurred'
    Message.error(message)
    return Promise.reject(error)
  }
)

export default apiClient
